// extracted by mini-css-extract-plugin
export default {"list":"Breadcrumbs--list--Nf2a7","item":"Breadcrumbs--item--4EKMq"};